import React from 'react';

import { TextInput, ActionIcon, Space, createStyles, Checkbox, Paper, Text, Tooltip } from '@mantine/core';
import { IconX, IconSearch, IconFilterOff } from '@tabler/icons-react';

const useStyles = createStyles(theme => ({
  header: {
    padding: theme.spacing.lg,
    borderRadius: 0,
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    display: 'grid',
    gridTemplateRows: 'auto',
    gridTemplateColumns: 'auto min-content min-content',
    gridTemplateAreas: `
        'search search search'
        'favorite . clear'
      `,
    alignItems: 'center',
    gap: theme.spacing.sm,
  },
  title: {
    gridArea: 'title',
  },
  favorite: {
    gridArea: 'favorite',
    whiteSpace: 'nowrap',
  },
  search: {
    gridArea: 'search',
  },
  clear: {
    gridArea: 'clear',
  },
}));

const ProductsHeader = ({
  search,
  setSearch,
  orderByFavorites,
  setOrderByFavorites,
  hideOrderByFavorites = false,
}: {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  orderByFavorites: boolean;
  setOrderByFavorites: React.Dispatch<React.SetStateAction<boolean>>;
  hideOrderByFavorites?: boolean;
}): JSX.Element => {
  const { classes, theme } = useStyles();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearch(value);
  };

  const handleOrderByFavorites = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = !!e.currentTarget?.checked;
    setOrderByFavorites(value);
  };

  const handleClearSearchFilter = (): void => {
    setSearch('');
  };

  const handleClearFilters = (): void => {
    setSearch('');
    setOrderByFavorites(false);
  };

  return (
    <Paper className={classes.header}>
      {!hideOrderByFavorites && (
        <Checkbox
          className={classes.favorite}
          checked={orderByFavorites}
          onChange={handleOrderByFavorites}
          label={
            <Text color='gray' fs='italic'>
              Order by Favorites
            </Text>
          }
        />
      )}
      <TextInput
        className={classes.search}
        icon={<IconSearch size={theme.fontSizes.md} />}
        placeholder={hideOrderByFavorites ? 'Search packages' : 'Search by product'}
        onChange={handleSearchChange}
        value={search}
        data-cy='retailItemSearch'
        rightSection={
          !!search ? (
            <ActionIcon onClick={handleClearSearchFilter} size='md'>
              <IconX size={theme.fontSizes.md} />
            </ActionIcon>
          ) : (
            <Space />
          )
        }
      />
      {!hideOrderByFavorites && (
        <Tooltip label='Clear filters' className={classes.clear}>
          <ActionIcon onClick={handleClearFilters}>
            <IconFilterOff />
          </ActionIcon>
        </Tooltip>
      )}
    </Paper>
  );
};

export default ProductsHeader;
